const revealTargets = () => Array.from(document.querySelectorAll("[data-form-reveal]"))

const controlFor = (source) => {
  const byData = document.querySelector(`[data-form-reveal-control="${source}"]`)
  if (byData) return byData

  return (
    document.querySelector(`select[name$="[${source}]"]`) ||
    document.querySelector(`input[name$="[${source}]"]`)
  )
}

const isActive = (target) => {
  const source = target.dataset.formRevealSource
  const value = target.dataset.formRevealValue
  const mode = target.dataset.formRevealMode || "select"
  if (!source || !value) return false

  if (mode === "checkbox") {
    const checked = Array.from(
      document.querySelectorAll(
        `input[type="checkbox"][name$="[${source}][]"]:checked, input[type="checkbox"][data-form-reveal-option]:checked`
      )
    )
    return checked.some((input) => input.value === value)
  }

  const control = controlFor(source)
  return Boolean(control && control.value === value)
}

const syncReveal = (target) => {
  target.hidden = !isActive(target)
}

const syncAll = () => {
  revealTargets().forEach(syncReveal)
}

export const initBackofficeParticipantFormReveals = () => {
  const targets = revealTargets()
  if (!targets.length) return

  syncAll()

  document.addEventListener("change", (event) => {
    const el = event.target
    if (!(el instanceof HTMLElement)) return
    if (
      el.matches("[data-form-reveal-control]") ||
      el.matches("[data-backoffice-select-field][data-form-reveal-control]") ||
      el.matches("select[name*='[activite]']") ||
      el.matches("select[name*='[fonction]']") ||
      el.matches("input[name*='[centres_interet]']")
    ) {
      syncAll()
    }
  })
}
